module.exports = __webpack_public_path__ + "static/media/Cowbells.a7ec8274.mp3";